import React from "react";
import { Box, useTheme } from "@mui/material";
import Typography from "components/basic/typography";
import {
  MEETING_STATUS_META,
  StatusCounts,
  StatusFilter,
  statusFilterLabel,
} from "../../types";

const CARDS: { key: StatusFilter; color?: string }[] = [
  { key: "all" },
  { key: "pending", color: MEETING_STATUS_META.pending.color },
  { key: "confirmed", color: MEETING_STATUS_META.confirmed.color },
  { key: "completed", color: MEETING_STATUS_META.completed.color },
  { key: "cancelled", color: MEETING_STATUS_META.cancelled.color },
];

interface StatCardsProps {
  counts: StatusCounts;
  selected: StatusFilter;
  onSelect: (status: StatusFilter) => void;
}

const StatCards: React.FC<StatCardsProps> = ({
  counts,
  selected,
  onSelect,
}) => {
  const theme = useTheme();
  return (
    // Deliberately not a Stack: its `spacing` is a sibling margin-left, so a
    // wrapped row gets no vertical gap and every wrapped card keeps a stray
    // indent. `gap` handles both axes.
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
      {CARDS.map((c) => {
        const isActive = selected === c.key;
        const accent = c.color ?? theme.palette.text.primary;
        return (
          <Box
            key={c.key}
            onClick={() => onSelect(c.key)}
            sx={{
              // Two per row on a phone rather than one tall column.
              flex: "1 1 130px",
              minWidth: 130,
              cursor: "pointer",
              border: `1px solid ${isActive ? accent : theme.palette.divider}`,
              borderTop: `3px solid ${accent}`,
              borderRadius: 1,
              p: 1.5,
              backgroundColor: isActive
                ? `${accent}12`
                : theme.palette.background.paper,
              transition: "background-color 120ms",
            }}
          >
            <Typography variant="h3" style={{ fontWeight: 700, color: accent }}>
              {counts[c.key]}
            </Typography>
            <Typography
              variant="caption"
              style={{ color: theme.palette.text.secondary }}
            >
              {statusFilterLabel(c.key)}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default StatCards;
